import styled, { css } from 'styled-components'

export const ChecklistItemWrap = styled.div`
  display: flex;
  gap: 8px;

  span {
    margin: 0;
  }

  label:not(:last-child) {
    margin: 0;
  }

  ${(p) =>
    p.isDone &&
    css`
      input {
        color: var(--t-checklist-input-done-text);
        text-decoration: line-through;
      }
    `}
`

export const CheckboxWrap = styled.label`
  padding-top: 14px;
`

export const ChecklistPointer = styled.div`
  min-width: 21px;
  text-align: center;
  padding-top: 13px;
`
